export const HANDLEERRROR ="HANDLEERRROR"
export const CLEARERROR = "CLEARERROR"